import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src="/logo.png" 
                alt="Chocados GDL Logo" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Tu mejor opción en vehículos de salvamento en Guadalajara. 
              Autos, camionetas, tractocamiones, autopartes y más.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a 
                href="https://facebook.com" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold uppercase tracking-wider text-foreground">
              Contacto
            </h4>
            <div className="space-y-3">
              <a 
                href="tel:+523314566426" 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>33 1456 6426</span>
              </a>
              <a 
                href="tel:+523319560912" 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>33 1956 0912</span>
              </a>
              <a 
                href="tel:+523325483444" 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>33 2548 3444</span>
              </a>
              <a 
                href="mailto:mondo_samuel@yahoo.com.mx" 
                className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors"
              >
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span className="text-sm">mondo_samuel@yahoo.com.mx</span>
              </a>
            </div>
          </div>

          {/* Location */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold uppercase tracking-wider text-foreground">
              Ubicación
            </h4>
            <div className="flex items-start gap-3 text-muted-foreground">
              <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
              <span>Periferico Poniente 5380-A, El Colli 45070, Zapopan, Jal.</span>
            </div>
            <Link 
              to="/contacto" 
              className="inline-block text-primary hover:text-primary/80 text-sm font-medium transition-colors"
            >
              Ver en mapa →
            </Link>
          </div>

          {/* Hours */}
          <div className="space-y-4">
            <h4 className="text-lg font-bold uppercase tracking-wider text-foreground">
              Horarios
            </h4>
            <div className="space-y-2 text-muted-foreground text-sm">
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-foreground">Lunes - Viernes</p>
                  <p>09:00 AM - 06:00 PM</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-foreground">Sábado</p>
                  <p>09:00 AM - 02:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="border-t border-border mt-12 pt-8">
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Inicio
            </Link>
            <Link to="/inventario" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Inventario
            </Link>
            <Link to="/servicios" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Servicios
            </Link>
            <Link to="/contacto" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Contacto
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} Chocados GDL. Todos los derechos reservados.
          </p>
          <p className="text-muted-foreground/60 text-sm">
            Aceptamos tarjetas y pagos en línea
          </p>
        </div>
      </div>
    </footer>
  );
};
